import { Vector2 } from 'three';

export function lineSideByPoint(line: Vector2[], point: Vector2) {
  const result =
    (point.x - line[0].x) * (line[1].y - line[0].y) -
    (line[1].x - line[0].x) * (point.y - line[0].y);

  return result / Math.abs(result);
}
